import { ApiClient } from '@/shared/api-client/api-client';
import { ICandidateProfile } from '@/shared/api-client/models';
import GenderIconComponent from '@/shared/components/gender-icon-component/gender-icon-component.vue';
import * as _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import CandidateLocationComponent from '../../../../shared/components/candidate-location-component/candidate-location-component.vue';
import CandidateProfilePictureComponent from '../candidate-profile-picture-component/candidate-profile-picture-component.vue';

interface IViewModel {

    isInitialized: boolean;

    isLoading: boolean;

    candidateProfile?: ICandidateProfile;
}

interface IModals {

    candidateProfileModalName: string;
}

@Component({
    components: {
        GenderIconComponent,
        CandidateProfilePictureComponent,
        CandidateLocationComponent
    }
})
export default class CandidateProfileModalComponent extends Vue {

    @Prop() public electionId!: string;
    @Prop() public showGender!: boolean;
    @Prop() public candidatureId!: string;
    @Prop() public translations!: { [key: string]: string; };
    @Prop({default: false}) public preventViewChangingLinks!: boolean;

    public viewModel: IViewModel = {

        isInitialized: false,

        isLoading: false,

        candidateProfile: undefined
    };

    public modals: IModals  = {

        candidateProfileModalName: `candidateProfileModal-${this.electionId}`
    };

    private apiClient: ApiClient = new ApiClient();

    public async openModal(): Promise<void> {

        this.loadCandidateProfile();

        $(`#${this.modals.candidateProfileModalName}`).modal('show');
    }

    public get hasLinks(): boolean {

        if (!this.viewModel.candidateProfile) {
            return false;
        }

        if (!this.viewModel.candidateProfile.links) {
            return false;
        }

        if (this.viewModel.candidateProfile.links.length <= 0) {
            return false;
        }

        return true;
    }

    public async loadCandidateProfile(): Promise<void> {

        this.viewModel.isLoading = true;

        try {

            const candidateProfile = await this.apiClient.candidature.getProfile(this.electionId, this.candidatureId);

            this.viewModel.candidateProfile = candidateProfile;

        } finally {

            this.viewModel.isInitialized = true;

            this.viewModel.isLoading = false;
        }
    }

    public get userProfileUrl(): string {

        return `/userProfile/show/users/${this.candidatureId}?electionId=${this.electionId}`;
    }
}
